import uniq from 'lodash/uniq';
import {
  DROPSHIP_PRODUCTS,
  DROPSHIP_PRODUCTS_OFFSET,
  DROPSHIP_PRODUCTS_COUNT,
  DROPSHIP_PRODUCTS_SEARCH,
  DROPSHIP_PRODUCTS_CHECK,
  DROPSHIP_PRODUCTS_UNCHECK,
  DROPSHIP_PRODUCTS_UNCHECK_ALL,
  DROPSHIP_PRODUCTS_LOADING,
  DROPSHIP_PRODUCTS_SUPPLIER_ID,
  DROPSHIP_PRODUCTS_BRANDS,
  DROPSHIP_PRODUCTS_CHECK_ALL_ON_PAGE,
  DROPSHIP_PRODUCTS_ALL,
  DROPSHIP_PRODUCTS_PRODUCT,
  DROPSHIP_PRODUCTS_PRODUCT_LOADING,
  DROPSHIP_PRODUCTS_MODAL_OPEN,
  DROPSHIP_PRODUCTS_MODAL_CLOSE,
  DROPSHIP_PRODUCTS_MODAL_PRODUCT,
  DROPSHIP_PRODUCTS_APPROVED,
  DROPSHIP_PRODUCTS_DETAILS,
  DROPSHIP_PRODUCTS_APPROVE,
  DROPSHIP_PRODUCTS_UNAPPROVE,
  DROPSHIP_PRODUCTS_LOADING_PRODUCTS,
} from '../constants/dropshipProductsTypes';

const initialState = {
  data: [],
  offset: 0,
  count: 0,
  perPage: 20,
  filters: {},
  currentFilter: {},
  search: '',
  checked: {},
  variants: [],
  supplierId: 0,
  brands: [],
  product: {
    variants: [],
    description_extra: '',
    images: [],
  },
  modal: false,
  modalProduct: {},
  productDetails: {},
  approved: [],
  unapproved: [],
  isLoading: false,
  isLoadingProducts: false,
  productIsLoading: false,
};

const dropshipProducts = (state = initialState, action) => {
  switch (action.type) {
    case DROPSHIP_PRODUCTS:
      return {
        ...state,
        data: action.payload,
      };
    case DROPSHIP_PRODUCTS_OFFSET:
      return {
        ...state,
        offset: action.payload,
      };
    case DROPSHIP_PRODUCTS_COUNT:
      return {
        ...state,
        count: +action.payload,
      };
    case DROPSHIP_PRODUCTS_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case DROPSHIP_PRODUCTS_CHECK:
      return {
        ...state,
        checked: {
          ...state.checked,
          [action.payload.model]: action.payload.variants,
        },
      };
    case DROPSHIP_PRODUCTS_UNCHECK:
      const newChecked = { ...state.checked };
      delete newChecked[action.payload.model];

      return {
        ...state,
        checked: newChecked,
      };
    case DROPSHIP_PRODUCTS_SUPPLIER_ID:
      return {
        ...state,
        supplierId: action.payload,
      };
    case DROPSHIP_PRODUCTS_BRANDS: {
      const data = action.payload.filter((item) => !!item.approved_for_ecommerce === true);
      return {
        ...state,
        brands: action.payload.map((item) => {
          return {
            value: item.supplier.id,
            label: item.supplier.small_logo_path,
            approved_for_ecommerce: item.approved_for_ecommerce,
            auto_sync: item.auto_sync,
          };
        }),
        supplierId: data.length > 0 ? data[0].supplier.id : 0,
      };
    }
    case DROPSHIP_PRODUCTS_CHECK_ALL_ON_PAGE:
      return {
        ...state,
        checked: {
          ...state.checked,
          ...action.payload,
        },
      };
    case DROPSHIP_PRODUCTS_UNCHECK_ALL:
      return {
        ...state,
        checked: {},
      };
    case DROPSHIP_PRODUCTS_ALL:
      const checkedAll = {};
      action.payload.forEach((product) => {
        checkedAll[product.model] = product.variants;
      });
      return {
        ...state,
        checked: checkedAll,
      };
    case DROPSHIP_PRODUCTS_PRODUCT:
      return {
        ...state,
        product: action.payload,
      };
    case DROPSHIP_PRODUCTS_PRODUCT_LOADING:
      return {
        ...state,
        productIsLoading: action.payload,
      };
    case DROPSHIP_PRODUCTS_MODAL_OPEN:
      return {
        ...state,
        modal: true,
      };
    case DROPSHIP_PRODUCTS_MODAL_CLOSE:
      return {
        ...state,
        modal: false,
      };
    case DROPSHIP_PRODUCTS_MODAL_PRODUCT:
      return {
        ...state,
        modalProduct: action.payload,
      };
    case DROPSHIP_PRODUCTS_APPROVED:
      return {
        ...state,
        approved: action.payload,
        unapproved: [],
      };
    case DROPSHIP_PRODUCTS_DETAILS:
      return {
        ...state,
        productDetails: action.payload,
      };
    case DROPSHIP_PRODUCTS_APPROVE:
      return {
        ...state,
        approved: uniq([...state.approved, ...action.payload]),
        unapproved: state.unapproved.filter((x) => !action.payload.includes(x)),
      };
    case DROPSHIP_PRODUCTS_UNAPPROVE:
      return {
        ...state,
        approved: state.approved.filter((x) => !action.payload.includes(x)),
        unapproved: uniq([...state.unapproved, ...action.payload]),
      };
    case DROPSHIP_PRODUCTS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case DROPSHIP_PRODUCTS_LOADING_PRODUCTS:
      return {
        ...state,
        isLoadingProducts: action.payload,
      };

    default:
      break;
  }

  return state;
};

export default dropshipProducts;
